import { initContactForm } from '../components/forms/initContactForm';

window.addEventListener('DOMContentLoaded', handleOnLoadPage, false);

function handleOnLoadPage() {
    initContactForm();
}
